export default "__VITE_ASSET__C4edoOlX__"